/** Semantic palette tokens applied to the document root on boot. */
export const THEME_COLORS = Object.freeze({
  primary: '#0096C7',
  info: '#2196F3',
  success: '#00BA86',
  warning: '#ECB639',
  error: '#EF476F',
  draft: '#9A968D',
  footer: '#0096C7',
  'footer-text': '#FFFFFF',
})

/** Default UI font until a group styling override applies `--font-family`. */
export const DEFAULT_FONT = 'Bai Jamjuree'

/** Google Fonts whitelist for the group-styling picker. */
export const AVAILABLE_FONTS = Object.freeze([
  'Bai Jamjuree',
  'Quicksand',
  'Roboto',
  'Lato',
  'Open Sans',
  'Inconsolata',
  'Montserrat',
  'Poppins',
  'Oswald',
  'Raleway',
  'Merriweather',
  'League Spartan',
  'Nunito Sans',
  'Roboto Serif',
  'Inter',
])
